var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sidebar-menu',{attrs:{"width":"300px","collapsed":"","menu":_vm.menu},on:{"item-click":_vm.onItemClick}})}
var staticRenderFns = []

export { render, staticRenderFns }